import { targetTiersApi } from '@texas/api/endpoints/targetTiers/targetTiersApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { AddMultipleTiersModal as SharedAddMultipleTiersModal } from '@texas/components/shared/tiers/AddMultipleTiersModal';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { articleManageEvents } from '../events';

interface Props extends SharedDisclosureProps {
  articleId: number;
  existingQuantities: number[];
}

export function AddMultipleTiersModal({
  articleId,
  existingQuantities,
  isOpen,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const {
    data: recommendedTiers,
    loading: loadingRecommended,
    refetch: refetchRecommended,
  } = useApiResource(targetTiersApi.recommended);

  useEffect(() => {
    if (isOpen) {
      refetchRecommended(articleId);
    }
  }, [articleId, isOpen, refetchRecommended]);

  const {
    request: addMultipleTiersRequest,
    loading: adding,
    error: addingError,
  } = useApiRequest(targetTiersApi.addMultipleTiers);

  return (
    <SharedAddMultipleTiersModal
      title={t('tiers.addMultiple')}
      existingQuantities={existingQuantities}
      recommendedQuantities={recommendedTiers?.map((t) => t.quantity) ?? []}
      loadingRecommendations={loadingRecommended}
      submitting={adding}
      submitError={addingError}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={async (quantities) => {
        const response = await addMultipleTiersRequest(articleId, quantities);
        if (!response.hasError) {
          articleManageEvents.tiersAdded.dispatch();
          return true;
        }
        return false;
      }}
    />
  );
}
